export { fetchPublisherData } from 'next-flight-server-reference-proxy-loader?id=0023bcb510aff8898ab7e26c1ea86f4e69210b6c93&name=fetchPublisherData!'